import { GitFork, LucideProps } from "lucide-react";
import { forwardRef } from "react";

export const Fork = forwardRef<SVGSVGElement, LucideProps>((props, ref) => (
  <GitFork ref={ref} {...props} style={{ transform: "rotate(180deg)" }} />
));

Fork.displayName = "Fork";
